"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getClassNames = void 0;

var _react = require("@fluentui/react");

var _AppBar = require("../AppBar/AppBar.classNames");

var getClassNames = (0, _react.memoizeFunction)(function () {
  var isContentFullBleed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    root: (0, _react.mergeStyles)({
      top: _AppBar.APP_BAR_HEIGHT + ' !important',
      // TODO: Figure out specificity issue
      selectors: {
        '.ms-Panel-content': isContentFullBleed ? {
          padding: 0
        } : null
      }
    }),
    header: (0, _react.mergeStyles)({
      display: 'flex',
      alignSelf: 'normal' + ' !important'
    }),
    headerText: (0, _react.mergeStyles)({
      flex: '1'
    }),
    headerNavigation: (0, _react.mergeStyles)({
      justifyContent: 'flex-end'
    })
  };
});
exports.getClassNames = getClassNames;